import React from "react"
import styled from "styled-components"
import { FormattedMessage } from "react-intl"
import { Colors } from "../../lib/theme/index"
import Text from "../../components/text"
import Box from "../../lib/ui/ui-box"

const StyledItem = styled.li`
  color: ${Colors.actionPrimary};
  font-weight: 700;
  font-family: Libre Baskerville;
  padding-left: 10px;
  margin-bottom: 12px;
`
const StyledList = styled.ul`
  list-style-position: outside;
  padding-left: 1.5em;
`
const WhoCanApply = props => {
  let whoCanApplyFactors = [
    "Homeowner in Ontario, Alberta or British Columbia",
    "Minimum proprety value of $250,000",
    "At least 55 years old",
    "Access up to $800,000 of tax free cash"
  ]
  return (
    <Box
      style={{ borderTop: "1px solid #DBDBDB" }}
      flexDirection="column"
      w={[1, 1, "990px"]}
      mt={[5, 5, 5]}
      ml={["auto"]}
      mr={["auto"]}
      justify={["flex-start"]}
      py={[5]}
      px={[4, 4, 0, 0]}
    >
      {/* Title */}
      <Text
        fontFamily="Libre Baskerville"
        color="#535353"
        fontSize={[2, 3, 4]}
        fontWeight="700"
        mb={[3, 3, 3]}
      >
        <FormattedMessage id="whocanapply.title" defaults="Who can apply?" />
      </Text>
      {/* List */}
      <StyledList>
        {whoCanApplyFactors.map((factor, index) => {
          return (
            <StyledItem key={`factor-${index}`}>
              <Text
                style={{ display: "inline" }}
                w={1}
                fontSize={[2, 2, 3, 3]}
                fontFamily="Libre Baskerville"
              >
                {factor}
              </Text>
            </StyledItem>
          )
        })}
      </StyledList>
    </Box>
  )
}

export default WhoCanApply



// WEBPACK FOOTER //
// ./src/components/who-can-apply/who-can-apply.component.js